export default "__VITE_ASSET__DPdxY$wQ__"